export default __webpack_public_path__ + "static/saluto_logo_white-af987c1df17f831e80f79317380bde25.png";